import { db } from './firebase';
import { doc, setDoc, getDoc, updateDoc, deleteDoc, collection, getDocs } from 'firebase/firestore';

const addDocumentInSubcollection = async (parentCollection, parentDocId, subCollection, docId, data) => {
  try {
    const subCollectionRef = doc(db, parentCollection, parentDocId, subCollection, docId);
    await setDoc(subCollectionRef, data);
    console.log("Document successfully added to subcollection!");
  } catch (e) {
    console.error("Error adding document to subcollection: ", e);
  }
};

const getDocumentsFromSubcollection = async (parentCollection, parentDocId, subCollection) => {
  try {
    const subCollectionRef = collection(db, parentCollection, parentDocId, subCollection);
    const querySnapshot = await getDocs(subCollectionRef);
    const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return documents;
  } catch (e) {
    console.error("Error getting documents from subcollection:", e);
    return [];
  }
};

const updateDocumentInSubcollection = async (parentCollection, parentDocId, subCollection, docId, updatedData) => {
  try {
    const subCollectionRef = doc(db, parentCollection, parentDocId, subCollection, docId);

    // Check if the document exists
    const docSnap = await getDoc(subCollectionRef);
    if (docSnap.exists()) {
      await updateDoc(subCollectionRef, updatedData);
      console.log("Document in subcollection successfully updated!");
    } else {
      // If document doesn't exist, create it with setDoc
      await setDoc(subCollectionRef, updatedData);
      console.log("Document did not exist; successfully created and updated!");
    }
  } catch (e) {
    console.error("Error updating document in subcollection:", e);
  }
};

const deleteDocumentFromSubcollection = async (parentCollection, parentDocId, subCollection, docId) => {
  try {
    const subCollectionRef = doc(db, parentCollection, parentDocId, subCollection, docId);
    await deleteDoc(subCollectionRef);
    console.log("Document successfully deleted from subcollection!");
  } catch (e) {
    console.error("Error deleting document from subcollection:", e);
  }
};

export { 
  addDocumentInSubcollection, 
  getDocumentsFromSubcollection, 
  updateDocumentInSubcollection, 
  deleteDocumentFromSubcollection 
};
